import Swiper from 'swiper';
import { EffectFade, Thumbs, Navigation, FreeMode, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
  const autoMoveSelectedThumb = (swiper) => {
    const { clickedIndex, visibleSlidesIndexes } = swiper;

    if (swiper.slides.length > visibleSlidesIndexes.length) {
      if (visibleSlidesIndexes[0] === clickedIndex) {
        swiper.slidePrev();
      }

      if (visibleSlidesIndexes[visibleSlidesIndexes.length - 1] === clickedIndex) {
        swiper.slideNext();
      }
    }
  };

  const productThumbs = new Swiper('.js-product-thumbs', {
    modules: [Navigation, FreeMode],
    slidesPerView: 4,
    spaceBetween: 16,
    // freeMode: true,
    grabCursor: true,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    navigation: {
      nextEl: '.js-product-thumbs-next',
      prevEl: '.js-product-thumbs-prev',
    },
  });

  const productPreview = new Swiper('.js-product-preview', {
    modules: [EffectFade, Thumbs, Pagination],
    spaceBetween: 0,
    effect: 'fade',
    // fadeEffect: {
    //   crossFade: true,
    // },
    thumbs: {
      swiper: productThumbs,
    },
    pagination: {
      el: '.js-product-preview-pagination',
    },
  });

  productThumbs.on('click', (swiper) => {
    autoMoveSelectedThumb(swiper);
  });

  productThumbs.on('slideChange', (swiper) => {
    autoMoveSelectedThumb(swiper);
  });
});
